import styled from 'styled-components';

export const StyledLabel = styled.label`
    font-size: 22px;
    margin-right: 6px;
`;
